import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useState } from "react";
import { SUMMARYSTATISTICSAGGREGATIONDATALIST, SUMMARYSTATISTICSAGGREGATIONVALUELIST } from "utility/constants";
import { getAggregateValue } from "utility/helper";

export interface SummaryStatisticsFilterComponentProps {
  signalList: string[];
  getFilteredSUmmaryStat: (value: any) => void;
}

const SummaryStatisticsFilterComponent = (props: SummaryStatisticsFilterComponentProps) => {
  const [signal, setSignal] = useState<string[]>([]);
  const [groupBy, setGroupBy] = useState<string[]>([]);
  const [aggregation, setAggregation] = useState<string>("");

  const resetFilters = () => {
    setSignal([]);
    setGroupBy([]);
    setAggregation('');
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
        marginBottom: "12px",
      }}
    > 
      <div style={{ 
        display: "flex",
        flexDirection: "row",
        width: "75%",
        justifyContent: "space-between",
        gap: '4px',
        }}
      >
        <FormControl style={{ width: "40%" }}>
          <InputLabel htmlFor="grouped-native-select">
            Signals
          </InputLabel>
          <Select
            multiple
            id="modelSelect"
            value={signal}
            onChange={(event) => {
              const {
                target: { value },
              } = event;
              setSignal(
                typeof value === 'string' ? value.split(',') : value,
              );
            }}
            input={<OutlinedInput label="Signals" />}
            renderValue={(selected) => selected.join(', ')}
          >
            {props?.signalList.map(
              (item: any, index: number) => (
                <MenuItem key={index} value={item}>
                  <Checkbox checked={signal.indexOf(item) > -1} />
                  <ListItemText primary={item} />
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
        <FormControl style={{ width: "40%" }}>
          <InputLabel htmlFor="grouped-native-select">Group By</InputLabel>
          <Select
            id="modelSelect"
            multiple
            value={groupBy}
            onChange={(event) => {
              const {
                target: { value },
              } = event;
              setGroupBy(typeof value === 'string' ? value.split(',') : value,);
            }}
            input={<OutlinedInput label="Group By" />}
            renderValue={(selected) => selected.join(', ')}
          >
            {SUMMARYSTATISTICSAGGREGATIONDATALIST?.map(
              (item: any, index: number) => (
                <MenuItem key={index} value={item.value}>
                  <Checkbox checked={groupBy.indexOf(item.value) > -1} />
                  <ListItemText primary={item.label} />
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
        <FormControl style={{ width: "40%" }}>
          <InputLabel htmlFor="grouped-native-select">Aggregation</InputLabel>
          <Select
            id="modelSelect"
            value={aggregation}
            onChange={(event) => {
              const {
                target: { value },
              } = event;
              setAggregation(value as string);
            }}
            renderValue={(selected) => getAggregateValue(selected, SUMMARYSTATISTICSAGGREGATIONVALUELIST)}
            input={<OutlinedInput label="Aggregation" />}
          >
            {SUMMARYSTATISTICSAGGREGATIONVALUELIST?.map(
              (item: any, index: number) => (
                <MenuItem key={index} value={item.value}>
                  <Checkbox checked={aggregation.indexOf(item.value) > -1} />
                  <ListItemText primary={item.label} />
                </MenuItem>
              )
            )}
          </Select>
        </FormControl>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: '8px',
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            props?.getFilteredSUmmaryStat({signal: signal, groupBy: groupBy, aggregation: aggregation})
          }}
          disabled={signal.length === 0 || !groupBy || !aggregation}
        >
          APPLY
        </Button>
        <Button
          variant="contained"
          onClick={resetFilters}
          disabled={signal.length === 0 && !groupBy && !aggregation}
        >
          RESET
        </Button>
      </div>
    </div>
  );
};

export default SummaryStatisticsFilterComponent;
  

